import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { switchMap } from 'rxjs/operators';
import { ObservableManager } from '../types/observableManager.type';
import { MuLayoutService } from '../sharedProtos/layout/mu-layout.service';

@Injectable({
  providedIn: 'any',
})
export class ContextResolverService  {
  constructor(private translateService: TranslateService, private layoutService: MuLayoutService) {
    /** */
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    return new Promise((resolve, _) => {
      const manager = new ObservableManager();
      manager
        .watch(
          this.layoutService.currentCountryValue.pipe(
            switchMap(countryVal => {
              const country = environment.countries.find(c => c.geoName === countryVal);
              const lang = country?.languageKey || 'es';
              this.translateService.resetLang(lang);
              this.translateService.currentLang = lang;
              return this.translateService.getTranslation(lang);
            })
          )
        )
        .subscribe(() => {
          resolve(true);
          manager.release();
        });
    });
  }
}
